var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSee2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8b03e;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g5594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5596"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.21,142.29h-54.37c-3.38,0-6.12-2.74-6.12-6.12s2.74-6.12,6.12-6.12h54.37c3.38,0,6.12,2.74,6.12,6.12s-2.74,6.12-6.12,6.12Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g5606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5608"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.78,263.69c-3.38,0-6.12-2.74-6.12-6.12v-108.4c0-10.54,8.58-19.12,19.12-19.12h6.88c3.38,0,6.12,2.74,6.12,6.12s-2.74,6.12-6.12,6.12h-6.88c-3.79,0-6.88,3.09-6.88,6.88v108.4c0,3.38-2.74,6.12-6.12,6.12Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g5610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5612"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.67,436.05h-6.88c-10.54,0-19.12-8.58-19.12-19.12v-110.8c0-3.38,2.74-6.12,6.12-6.12s6.12,2.74,6.12,6.12v110.8c0,3.79,3.09,6.88,6.88,6.88h6.88c3.38,0,6.12,2.74,6.12,6.12s-2.74,6.12-6.12,6.12Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g5614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5616"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.21,436.05h-54.37c-3.38,0-6.12-2.74-6.12-6.12s2.74-6.12,6.12-6.12h54.37c3.38,0,6.12,2.74,6.12,6.12s-2.74,6.12-6.12,6.12Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g5618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5620"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.94,436.05h-55.34c-3.38,0-6.12-2.74-6.12-6.12s2.74-6.12,6.12-6.12h55.34c3.38,0,6.12,2.74,6.12,6.12s-2.74,6.12-6.12,6.12Z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g5622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5624"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.55,436.05h-6.51c-3.38,0-6.12-2.74-6.12-6.12s2.74-6.12,6.12-6.12h6.51c3.79,0,6.88-3.09,6.88-6.88v-20.4c0-3.38,2.74-6.12,6.12-6.12s6.12,2.74,6.12,6.12v20.4c0,10.54-8.58,19.12-19.12,19.12Z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g5626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5628"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.55,374.07c-3.38,0-6.12-2.74-6.12-6.12v-61.82c0-3.38,2.74-6.12,6.12-6.12s6.12,2.74,6.12,6.12v61.82c0,3.38-2.74,6.12-6.12,6.12Z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g5630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5632"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.55,263.69c-3.38,0-6.12-2.74-6.12-6.12v-108.4c0-3.79-3.09-6.88-6.88-6.88h-6.51c-3.38,0-6.12-2.74-6.12-6.12s2.74-6.12,6.12-6.12h6.51c10.54,0,19.12,8.58,19.12,19.12v108.4c0,3.38-2.74,6.12-6.12,6.12Z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g5634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5636"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.94,142.29h-55.34c-3.38,0-6.12-2.74-6.12-6.12s2.74-6.12,6.12-6.12h55.34c3.38,0,6.12,2.74,6.12,6.12s-2.74,6.12-6.12,6.12Z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g5638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5640"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.66,182.41c-10.13,0-18.37-8.23-18.37-18.34s8.24-18.34,18.37-18.34,18.37,8.23,18.37,18.34-8.24,18.34-18.37,18.34ZM245.66,157.96c-3.38,0-6.13,2.74-6.13,6.1s2.75,6.1,6.13,6.1,6.13-2.74,6.13-6.1-2.75-6.1-6.13-6.1Z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g5642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5644"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.66,157.96c-3.38,0-6.12-2.74-6.12-6.12v-72.71c0-3.38,2.74-6.12,6.12-6.12s6.12,2.74,6.12,6.12v72.71c0,3.38-2.74,6.12-6.12,6.12Z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g5646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5648"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.77,182.41c-10.13,0-18.37-8.23-18.37-18.34s8.24-18.34,18.37-18.34,18.37,8.23,18.37,18.34-8.24,18.34-18.37,18.34ZM142.77,157.96c-3.38,0-6.13,2.74-6.13,6.1s2.75,6.1,6.13,6.1,6.13-2.74,6.13-6.1-2.75-6.1-6.13-6.1Z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g5650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5652"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.77,157.96c-3.38,0-6.12-2.74-6.12-6.12v-72.71c0-3.38,2.74-6.12,6.12-6.12s6.12,2.74,6.12,6.12v72.71c0,3.38-2.74,6.12-6.12,6.12Z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g5654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5656"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.82,182.41c-10.13,0-18.37-8.23-18.37-18.34s8.24-18.34,18.37-18.34,18.37,8.23,18.37,18.34-8.24,18.34-18.37,18.34ZM348.82,157.96c-3.38,0-6.13,2.74-6.13,6.1s2.75,6.1,6.13,6.1,6.13-2.74,6.13-6.1-2.75-6.1-6.13-6.1Z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "g5658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5660"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.82,157.96c-3.38,0-6.12-2.74-6.12-6.12v-72.71c0-3.38,2.74-6.12,6.12-6.12s6.12,2.74,6.12,6.12v72.71c0,3.38-2.74,6.12-6.12,6.12Z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "g5662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5664"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.57,109.7c-10.13,0-18.37-8.23-18.37-18.34s8.24-18.34,18.37-18.34,18.37,8.23,18.37,18.34-8.24,18.34-18.37,18.34ZM193.57,85.25c-3.38,0-6.13,2.74-6.13,6.1s2.75,6.1,6.13,6.1,6.13-2.74,6.13-6.1-2.75-6.1-6.13-6.1Z"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "g5666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5668"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 187.46,
    y: 103.58,
    width: 12.24,
    height: 32.59
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "g5670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5672"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.24,109.7c-10.13,0-18.37-8.23-18.37-18.34s8.24-18.34,18.37-18.34,18.37,8.23,18.37,18.34-8.24,18.34-18.37,18.34ZM297.24,85.25c-3.38,0-6.13,2.74-6.13,6.1s2.75,6.1,6.13,6.1,6.13-2.74,6.13-6.1-2.75-6.1-6.13-6.1Z"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "g5674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5676"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 291.12,
    y: 103.58,
    width: 12.24,
    height: 32.59
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "g5678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5680"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.66,418.06c-10.13,0-18.37-8.23-18.37-18.34s8.24-18.34,18.37-18.34,18.37,8.23,18.37,18.34-8.24,18.34-18.37,18.34ZM245.66,393.61c-3.38,0-6.13,2.74-6.13,6.1s2.75,6.1,6.13,6.1,6.13-2.74,6.13-6.1-2.75-6.1-6.13-6.1Z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "g5682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5684"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.66,490.77c-3.38,0-6.12-2.74-6.12-6.12v-72.71c0-3.38,2.74-6.12,6.12-6.12s6.12,2.74,6.12,6.12v72.71c0,3.38-2.74,6.12-6.12,6.12Z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "g5686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5688"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.77,418.06c-10.13,0-18.37-8.23-18.37-18.34s8.24-18.34,18.37-18.34,18.37,8.23,18.37,18.34-8.24,18.34-18.37,18.34ZM142.77,393.61c-3.38,0-6.13,2.74-6.13,6.1s2.75,6.1,6.13,6.1,6.13-2.74,6.13-6.1-2.75-6.1-6.13-6.1Z"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "g5690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5692"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.77,490.77c-3.38,0-6.12-2.74-6.12-6.12v-72.71c0-3.38,2.74-6.12,6.12-6.12s6.12,2.74,6.12,6.12v72.71c0,3.38-2.74,6.12-6.12,6.12Z"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "g5694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5696"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.82,418.06c-10.13,0-18.37-8.23-18.37-18.34s8.24-18.34,18.37-18.34,18.37,8.23,18.37,18.34-8.24,18.34-18.37,18.34ZM348.82,393.61c-3.38,0-6.13,2.74-6.13,6.1s2.75,6.1,6.13,6.1,6.13-2.74,6.13-6.1-2.75-6.1-6.13-6.1Z"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "g5698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5700"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.82,490.77c-3.38,0-6.12-2.74-6.12-6.12v-72.71c0-3.38,2.74-6.12,6.12-6.12s6.12,2.74,6.12,6.12v72.71c0,3.38-2.74,6.12-6.12,6.12Z"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "g5702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5704"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.57,490.77c-10.13,0-18.37-8.23-18.37-18.34s8.24-18.34,18.37-18.34,18.37,8.23,18.37,18.34-8.24,18.34-18.37,18.34ZM193.57,466.32c-3.38,0-6.13,2.74-6.13,6.1s2.75,6.11,6.13,6.11,6.13-2.74,6.13-6.11-2.75-6.1-6.13-6.1Z"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "g5706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5708"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 187.46,
    y: 427.61,
    width: 12.24,
    height: 32.59
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "g5710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5712"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.24,490.77c-10.13,0-18.37-8.23-18.37-18.34s8.24-18.34,18.37-18.34,18.37,8.23,18.37,18.34-8.24,18.34-18.37,18.34ZM297.24,466.32c-3.38,0-6.13,2.74-6.13,6.1s2.75,6.11,6.13,6.11,6.13-2.74,6.13-6.11-2.75-6.1-6.13-6.1Z"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "g5714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5716"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 291.12,
    y: 427.61,
    width: 12.24,
    height: 32.59
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "g5718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5720"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.49,300.13c-10.12,0-18.34-8.24-18.34-18.37s8.23-18.37,18.34-18.37,18.34,8.24,18.34,18.37-8.23,18.37-18.34,18.37ZM363.49,275.63c-3.37,0-6.11,2.75-6.11,6.13s2.74,6.13,6.11,6.13,6.1-2.75,6.1-6.13-2.74-6.13-6.1-6.13Z"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "g5722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5724"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448.42,287.88h-72.71c-3.38,0-6.12-2.74-6.12-6.12s2.74-6.12,6.12-6.12h72.71c3.38,0,6.12,2.74,6.12,6.12s-2.74,6.12-6.12,6.12Z"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "g5726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5728"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M436.2,248.04c-10.11,0-18.34-8.24-18.34-18.37s8.23-18.37,18.34-18.37,18.34,8.24,18.34,18.37-8.23,18.37-18.34,18.37ZM436.2,223.54c-3.37,0-6.1,2.75-6.1,6.13s2.74,6.13,6.1,6.13,6.1-2.75,6.1-6.13-2.74-6.13-6.1-6.13Z"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "g5730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5732"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.38,
    y: 223.55,
    width: 32.59,
    height: 12.24
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "g5734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5736"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M436.2,351.7c-10.11,0-18.34-8.24-18.34-18.37s8.23-18.37,18.34-18.37,18.34,8.24,18.34,18.37-8.23,18.37-18.34,18.37ZM436.2,327.21c-3.37,0-6.1,2.75-6.1,6.13s2.74,6.13,6.1,6.13,6.1-2.75,6.1-6.13-2.74-6.13-6.1-6.13Z"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "g5738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5740"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 391.38,
    y: 327.22,
    width: 32.59,
    height: 12.24
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "g5742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5744"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.84,300.13c-10.11,0-18.34-8.24-18.34-18.37s8.23-18.37,18.34-18.37,18.34,8.24,18.34,18.37-8.23,18.37-18.34,18.37ZM127.84,275.63c-3.37,0-6.1,2.75-6.1,6.13s2.74,6.13,6.1,6.13,6.11-2.75,6.11-6.13-2.74-6.13-6.11-6.13Z"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "g5746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5748"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.61,287.88H42.91c-3.38,0-6.12-2.74-6.12-6.12s2.74-6.12,6.12-6.12h72.71c3.38,0,6.12,2.74,6.12,6.12s-2.74,6.12-6.12,6.12Z"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "g5750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5752"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.13,248.04c-10.11,0-18.34-8.24-18.34-18.37s8.23-18.37,18.34-18.37,18.34,8.24,18.34,18.37-8.23,18.37-18.34,18.37ZM55.13,223.54c-3.37,0-6.1,2.75-6.1,6.13s2.74,6.13,6.1,6.13,6.1-2.75,6.1-6.13-2.74-6.13-6.1-6.13Z"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "g5754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5756"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.35,
    y: 223.55,
    width: 32.59,
    height: 12.24
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "g5758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5760"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.13,351.7c-10.11,0-18.34-8.24-18.34-18.37s8.23-18.37,18.34-18.37,18.34,8.24,18.34,18.37-8.23,18.37-18.34,18.37ZM55.13,327.21c-3.37,0-6.1,2.75-6.1,6.13s2.74,6.13,6.1,6.13,6.1-2.75,6.1-6.13-2.74-6.13-6.1-6.13Z"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "g5762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5764"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.35,
    y: 327.22,
    width: 32.59,
    height: 12.24
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "g5766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5768"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.66,369.34c-48.33,0-87.65-39.32-87.65-87.65s39.32-87.65,87.65-87.65,87.65,39.32,87.65,87.65c0,17.51-5.15,34.41-14.88,48.88-1.89,2.8-5.69,3.55-8.49,1.66-2.8-1.89-3.55-5.69-1.66-8.49,8.37-12.44,12.8-26.98,12.8-42.04,0-41.58-33.83-75.41-75.42-75.41s-75.41,33.83-75.41,75.41,33.83,75.42,75.41,75.42c16.06,0,31.4-4.98,44.34-14.4,2.73-1.99,6.56-1.39,8.55,1.35s1.39,6.56-1.35,8.55c-15.05,10.96-32.87,16.75-51.54,16.75Z"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "g5770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5772"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.66,330.47c-26.9,0-48.78-21.88-48.78-48.78,0-15.72,7.65-30.57,20.46-39.72,2.75-1.96,6.57-1.33,8.54,1.42,1.96,2.75,1.33,6.57-1.42,8.54-9.6,6.86-15.33,17.98-15.33,29.76,0,20.15,16.39,36.54,36.55,36.54s36.55-16.39,36.55-36.54c0-11.78-5.73-22.91-15.33-29.76-2.75-1.96-3.39-5.79-1.42-8.54s5.79-3.39,8.54-1.42c12.81,9.15,20.46,24,20.46,39.72,0,26.9-21.88,48.78-48.78,48.78Z"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "g5774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path5776"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.66,272.27c-3.38,0-6.12-2.74-6.12-6.12v-27.13c0-3.38,2.74-6.12,6.12-6.12s6.12,2.74,6.12,6.12v27.13c0,3.38-2.74,6.12-6.12,6.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSee2);
export default __webpack_public_path__ + "static/media/see2.d72bd4791b572502ee0c9dee1744f13e.svg";
export { ForwardRef as ReactComponent };